import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { EditImage } from '@/views/Automation/CampaignCreatorV2/components/Modals/CcAddImageModal/types';
import CcModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcModal.ts.vue';
import { ImageCreative, SupportedCrop } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/AdCreative';
import { timeout } from '@sh/helpers';
import { computed, ref } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

interface Props {
  image: NullableType<EditImage>;
}

interface Emits {
  (event: 'onCancel'): void;
  (event: 'onSave', value: ImageCreative): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcCropImageModal.ts',
  props: {
    image: null
  },
  emits: ["onCancel", "onSave"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onCancel'): void;
  (event: 'onSave', value: ImageCreative): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  image: NullableType<EditImage>;
};





const isReady = ref(false);

const advancedCropper = ref<Cropper | null>(null);

const imageURL = computed(
  () =>
    props.image?.image_url?.replace(
      'mediamanager-images.theoptimizerimg.com',
      'mediamanager-images.s3.amazonaws.com'
    ) ?? 'https://dummyimage.com/300.png/09f/fff'
);

function onCropperReady() {
  setTimeout(() => {
    isReady.value = true;
  }, timeout);
}

function onCancelClick() {
  isReady.value = false;
  emits('onCancel');
}

function onSaveClick() {
  const data = advancedCropper.value?.getResult();
  isReady.value = false;

  if (!(data && props.image)) {
    return;
  }

  const topLeft: number[] = [data.coordinates.left, data.coordinates.top];
  const bottomRight: number[] = [
    data.coordinates.left + data.coordinates.width,
    data.coordinates.top + data.coordinates.height,
  ];

  const editedImage: ImageCreative & Partial<Pick<EditImage, 'aspectRatio'>> = {
    ...props.image,
    aspectRatio: undefined,
    cropVariations: {
      ...(props.image.cropVariations || {}),
      [props.image.aspectRatio!.value as SupportedCrop]: {
        coordinates: data.coordinates,
        pixelCoordinates: [topLeft, bottomRight],
        cropRatio: props.image.aspectRatio!.value as SupportedCrop,
        useCrop: true,
        width: data.image.width,
        height: data.image.height,
        transforms: data.image.transforms,
      },
    },
  };

  emits('onSave', editedImage);
}

return { __sfc: true,props, emits, isReady, advancedCropper, imageURL, onCropperReady, onCancelClick, onSaveClick, CcIcon, CcModal, Cropper }
}

})